import React from 'react';
import { Card, CardContent, CardHeader } from './ui/Card';
import { Compass, Layers, Landmark, BarChart3 } from 'lucide-react';
const services = [{
  title: 'Wealth Orchestration',
  description: 'Holistic synchronization of your assets, liabilities, and income streams into a cohesive symphony of growth.',
  icon: Compass
}, {
  title: 'Capital Trajectory Planning',
  description: 'Advanced modeling to project and optimize your investment path across multiple market scenarios.',
  icon: BarChart3
}, {
  title: 'Legacy Architecture',
  description: 'Structural design of your estate to ensure seamless transfer of wealth and values to future generations.',
  icon: Landmark
}, {
  title: 'Liquidity Mapping',
  description: 'Strategic cash flow analysis to maintain optimal solvency while maximizing capital efficiency.',
  icon: Layers
}];
export function Services() {
  return <section className="py-24 bg-white" data-id="element-71">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-72">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-73">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl mb-4" data-id="element-74">
            Specialized Financial Disciplines
          </h2>
          <p className="text-lg text-slate-600" data-id="element-75">
            We move beyond basic planning to provide institutional-grade
            financial architecture for private clients.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-76">
          {services.map((service, index) => <Card key={index} className="h-full hover:shadow-md transition-shadow duration-300 border-slate-100 bg-slate-50/50" data-id="element-77">
              <CardHeader data-id="element-78">
                <div className="w-12 h-12 bg-blue-900 rounded-lg flex items-center justify-center mb-4" data-id="element-79">
                  <service.icon className="h-6 w-6 text-white" data-id="element-80" />
                </div>
                <h3 className="text-xl font-semibold text-slate-900" data-id="element-81">
                  {service.title}
                </h3>
              </CardHeader>
              <CardContent data-id="element-82">
                <p className="text-slate-600 leading-relaxed" data-id="element-83">
                  {service.description}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}